import * as types from "./invoicesActionTypes";

export function setInvoicesRefresh(value) {
  return {
    type: types.REFRESH_INVOICES_DATATABLE,
    value,
  };
}



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/invoices/invoiceActions.js